import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
  { label: "Inventory", path: "/app/stock/levels" },
  { label: "Movements", path: "/app/stock/movements" },
];

/**
 * Small "Inventory | Movements" pill nav shown on the Adjust Stock and New
 * Transfer pages, so those actions can jump straight to the stock levels or
 * movements views without going back through the sidebar.
 */
const StockSubNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="flex items-center gap-1.5 rounded-full border border-gray-200 p-1 dark:border-gray-700">
      {TABS.map((tab) => {
        const active = location.pathname === tab.path;
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition ${
              active
                ? "bg-primary-600 text-white"
                : "text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default StockSubNav;
